import React, { Component } from 'react'

import axios from 'axios'
import swal from 'sweetalert'
import { connect } from 'react-redux'
import { FormGroup, FormControl, ControlLabel, Checkbox, Col, Button, Alert, Row, Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap'
import { addClient } from '../../login/reducers/manageLogin'

import getServerURL from '../../../functions/getServerURL'

import '../style.css'

class AddClient extends Component {

  state = {
    name: "",
    shortCode: "",
    // subdomain: "",
    managedByGenesis: true,
    displayAlert: false,
  }


  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  toggleCheckbox = (e) => this.setState({ [e.target.name]: !this.state[e.target.name] })


  handleSubmit = () => {

    const { name, shortCode, 
      // subdomain, 
      managedByGenesis } = this.state

    axios({
      url: `${getServerURL()}client/`,
      method: "POST",
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      data: {
        name,
        // subdomain: subdomain.toLowerCase(),
        short_code: shortCode.toUpperCase(),
        managed_by_genesis: managedByGenesis,
        created_by: this.props.currentUser.url,
      }
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The client has been created",
        icon: "success",
        button: "Continue",
      })

      this.props.addClient(response.data)

      this.setState({
        name: "",
        shortCode: "",
        subdomain: "",
        managedByGenesis: true,
        displayAlert: false
      })
    })
    .catch(error => {
      let errorMessage = ""

      if (error.response && error.response.data) {
        const { name, short_code, subdomain } = error.response.data

        if (subdomain && subdomain[0]) {
          errorMessage ='Subdomain: '+ subdomain[0]
        } else if (name && name[0]) {
          errorMessage = 'Name: '+ name[0]
        } else if (short_code && short_code[0]) {
          errorMessage = 'Short Code: ' + short_code[0]
        }
      }

      swal({
        title: "Error",
        text: `There was an error creating the client: ${errorMessage}`,
        icon: "error",
        button: "Continue",
      });
    })
  }


  render () {

    const { name, shortCode, managedByGenesis, displayAlert } = this.state

    const managedByGenesisInfoPopover = (
      <Popover id='manager-info-popover' title="Managed by Genesis">
        <p>
          If a client is managed by Genesis, their project data will be displayed on both their own version of PTOR and <a href="https://genesis.ptor.io">genesis.ptor.io</a> to allow for collaborative work with clients.
        </p>

        <p>
          If clients are <strong>not</strong> managed by Genesis, their project data will only be available on their own version of PTOR and not on <a href="https://genesis.ptor.io">genesis.ptor.io</a>.
        </p>
      </Popover>
    )

    return (
      <div id="AddClient">
        <Row>

          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Client Name <span className="required">*</span>
              </ControlLabel>
              <FormControl
                type="text"
                name="name"
                value={name}
                placeholder="Enter Client Name here..."
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Short Code <span className="required">*</span>
              </ControlLabel>
              <FormControl
                type="text"
                name="shortCode"
                value={shortCode.toUpperCase()}
                placeholder="Enter Department Short Code here..."
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>

        </Row>

        <Row>
          {/* <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Subdomain <span className="required">*</span>
              </ControlLabel>
              <FormControl
                type="text"
                name="subdomain"
                value={subdomain.toLowerCase()}
                placeholder="Enter client subdomain here..."
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col> */}

          <Col md={6}>
            <div id="managedByGenesisCheckbox">
              <Checkbox
                name='managedByGenesis'
                checked={managedByGenesis}
                onChange={this.toggleCheckbox}
              >
                <strong>
                  Managed by Genesis?
                </strong> &nbsp;
                <OverlayTrigger
                  trigger={["hover", "focus", "click"]}
                  placement="right"
                  overlay={managedByGenesisInfoPopover}
                >
                  <Glyphicon glyph='info-sign' />
                </OverlayTrigger>
              </Checkbox>
            </div>
          </Col>
        </Row>

        {displayAlert ?
          <Alert bsStyle="danger" onDismiss={() => this.setState({displayAlert: false})}>
            <h4>Please fill out all required fields</h4>
            <p>
              Required fields are marked with <span className="required">*</span>
            </p>
          </Alert>
          :
          null
        }
        <br/>
        <center>
          <Button bsStyle="primary" onClick={this.handleSubmit}>Submit</Button>
        </center>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps, { addClient })(AddClient);



// WEBPACK FOOTER //
// ./src/routes/manager/components/AddClient.js